export default function Page() { return <div>AboutUs Page</div>; }